import translations from './translations'

translations.add('es', {
    description: 'Póngase en contacto con la tienda para resolver este problema',
    close: 'CERRAR'
})
